<script>
  import BackToTopButton from "./BackToTopButton.svelte";

  export let href = "#";

  let verticalScrollPre = 0;
  let verticalScrollNext = 0;
  let scrollingUp = false;
  let scrolledToTheTop = true;

  $: {
    scrollingUp = verticalScrollPre > verticalScrollNext;
    scrolledToTheTop = scrollingUp && verticalScrollPre > 0 && verticalScrollNext === 0;

    verticalScrollPre = verticalScrollNext;
  }
</script>

<svelte:window bind:scrollY={verticalScrollNext} />

<!-- this needs to sit above main content, but beneath cookie banner -->
<div
  class="fixed bottom-48 lg:bottom-72 -right-144 focus-within:right-0 transition-all duration-300 ease-in-out"
  class:!right-0={scrollingUp && !scrolledToTheTop}
  class:invisible={scrolledToTheTop}
>
  <BackToTopButton {href} />
</div>
